// FileUploadModal.js - Direct Upload Version (No UI Modal)
import React from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://hms.backend.hiragroupcloud.com';

const FileUploadModal = ({ onUploadStart, onUploadSuccess, onUploadError }) => {
  
  // Direct file upload function - opens file explorer directly
  const openFileExplorer = (caseNumber) => {
    // Create hidden file input element
    const fileInput = document.createElement('input');
    fileInput.type = 'file';
    fileInput.multiple = true;
    fileInput.accept = '.png,.jpg,.jpeg,.stl,.pdf,.ply,.zip,.doc,.docx,.xls,.xlsx,.dcm';
    
    fileInput.onchange = async (event) => {
      const files = Array.from(event.target.files);
      if (files.length === 0) return;
      
      // Notify parent that upload started
      if (onUploadStart) onUploadStart(caseNumber);
      
      const formData = new FormData();
      files.forEach(file => {
        formData.append('files', file);
      });
      
      try {
        const response = await axios.post(
          `${API_URL}/api/cases/${caseNumber}/upload`,
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
            withCredentials: true,
          }
        );
        
        if (response.data.success) {
          // Notify parent of success
          if (onUploadSuccess) onUploadSuccess(caseNumber, response.data);
        } else {
          if (onUploadError) onUploadError(caseNumber, response.data.message);
        }
      } catch (error) {
        console.error('Upload error:', error);
        let errorMessage = 'Upload failed';
        if (error.response?.data?.message) {
          errorMessage = error.response.data.message;
        } else if (error.message) {
          errorMessage = error.message;
        }
        if (onUploadError) onUploadError(caseNumber, errorMessage);
      }
    };
    
    fileInput.click();
  };
  
  return { openFileExplorer };
};

export default FileUploadModal;